module.exports = {"magic":"Magic","disease":"Disease","poison":"Poison","curse":"Curse","enrage":"Enrage","none":"None","n_a":"N/A","unknown":"Unknown"};